import React, { useRef } from 'react';

const ManualCertificate = () => {

  const handlePrint = () => {
    window.print();
  };

  const gramPradhanName = "श्रीमती प्रीति त्यागी";

  return (
    <>
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .certificate-print-area, .certificate-print-area * {
              visibility: visible;
            }
            .certificate-print-area {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
            .no-print {
              display: none;
            }
            .fill-in {
              border-bottom: 1px dotted black;
              padding: 0 5px;
              margin: 0 2px;
              min-width: 100px; /* Adjust as needed */
              display: inline-block;
            }
          }
          .fill-in {
            border-bottom: 1px dotted black;
            padding: 0 5px;
            margin: 0 2px;
            min-width: 100px; /* Adjust as needed */
            display: inline-block;
          }
        `}
      </style>
      <div className="bg-gray-100 min-h-screen py-10">
        <div className="w-full max-w-4xl mx-auto mb-6 flex justify-end px-4 sm:px-0 no-print">
          <button onClick={handlePrint} className="bg-blue-600 text-white font-bold py-2 px-6 rounded-lg hover:bg-blue-700">
            Print Blank Certificate
          </button>
        </div>

        <div className="certificate-container bg-white w-full max-w-4xl mx-auto p-6 shadow-lg certificate-print-area">
          <div className="border-4 border-double border-gray-800 p-5 relative">
            <div className="absolute inset-0 flex justify-center items-center z-0">
              <img src="/logo.png" alt="Logo Watermark" className="w-64 h-64 opacity-10" />
            </div>
            <div className="relative z-10">
              <div className="text-center mb-4">
                <h1 className="text-4xl font-bold text-gray-800">ग्राम पंचायत सिखेड़ा</h1>
                <p className="text-lg text-gray-600">तहसील - बुलंदशहर, जनपद - बुलंदशहर, उत्तर प्रदेश</p>
              </div>

              <div className="text-center my-4">
                  <div className="flex justify-center items-center gap-4 text-xl font-semibold">
                      <label className="flex items-center"><input type="checkbox" className="mr-2 h-5 w-5"/> निवास प्रमाण-पत्र</label>
                      <label className="flex items-center"><input type="checkbox" className="mr-2 h-5 w-5"/> जाति प्रमाण-पत्र</label>
                      <label className="flex items-center"><input type="checkbox" className="mr-2 h-5 w-5"/> आय प्रमाण-पत्र</label>
                  </div>
              </div>

              <div className="flex justify-between items-start mt-6 mb-6">
                  <div className="text-lg leading-relaxed text-justify flex-grow">
                      <p className="indent-8">प्रमाणित किया जाता है कि <span className="fill-in" style={{minWidth: '200px'}}></span> पुत्र/पुत्री श्री <span className="fill-in" style={{minWidth: '200px'}}></span>, माता श्रीमती <span className="fill-in" style={{minWidth: '200px'}}></span>, जन्म तिथि <span className="fill-in"></span>, ग्राम व पोस्ट <strong>सिखेड़ा</strong>, तहसील <strong>बुलंदशहर</strong>, जनपद <strong>बुलंदशहर</strong> के निवासी हैं तथा मैं इनको भली भांति जानता हूँ।</p>
                      <p className="mt-4 indent-8">यह पंचायत में <span className="fill-in"></span> निवास करते हैं। इनकी जाति <span className="fill-in"></span> है, जो <span className="fill-in"></span> वर्ग के अंतर्गत आती है। इनके परिवार की आय का मुख्य साधन <span className="fill-in"></span> है।</p>
                      <p className="mt-4 indent-8">मैं इनके उज्ज्वल भविष्य की कामना करता हूँ।</p>
                  </div>
                  <div className="ml-6 flex-shrink-0">
                      <div className="w-32 h-40 border-2 border-gray-400 p-1 flex justify-center items-center text-gray-500 text-sm">फोटो चिपकाएँ</div>
                  </div>
              </div>

              <div className="flex justify-between items-end mt-8 pt-12">
                <div className="text-sm">
                  <p><strong>जारी करने की तिथि:</strong> <span className="fill-in" style={{minWidth: '120px'}}></span></p>
                  <p><strong>सीरियल नंबर:</strong> <span className="fill-in" style={{minWidth: '180px'}}></span></p>
                </div>
                <div className="text-center">
                  <div style={{height: '80px'}} className="w-auto mx-auto"></div>
                  <p className="border-t-2 border-gray-700 pt-1 mt-1 font-bold">{gramPradhanName}</p>
                  <p className="font-semibold">ग्राम प्रधान</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManualCertificate;
